module.exports = __webpack_public_path__ + "static/media/miljana-miljkovic.811aa264.jpg";